<template>
  <LayoutAuto fullScreen id="approvalPrint">
    <div class="main-wrap">
      <div class="right-wrap">
        <i v-if="approvalInfoLoad" class="el-icon-loading"></i>
        <img v-else-if="approvalInfoErr" src="../../assets/images/no_data.png">
        <template v-else>
          <div class="info-tip el-icon-warning nonprint" v-if="approvalInfo.tipInfo" v-html="approvalInfo.tipInfo"></div>
          <div class="title">
            <span class="name">
              <el-popover v-if="approvalInfo.helpInfo" placement="top" width="380" trigger="hover">
                <p v-html="approvalInfo.helpInfo"></p>
                <!-- <i class="iconfont iconquestion-circle nonprint" slot="reference"></i> -->
              </el-popover>
              {{approvalInfo.approvalName}}
            </span>
            <div class="bar-code">
              <BarCode v-if="approvalInfo.isBarcode" :value="approvalInfo.approvalId" :options="options" class="barcode"></BarCode>
              <div v-else class="approval-id">{{approvalInfo.approvalId}}</div>
            </div>
            <div class="approval-status-print" :style="{'color': statusColor}">{{statusNameMap}}</div>
          </div>
          <div class="form-list">
            <el-collapse v-model="activeNames">
              <Sponsor 
                ref="sponsor" 
                :approvalInfo="approvalInfo" 
                childMaxHeight="550px" 
                childWidth="27cm"
              />
              <el-collapse-item class="process-title" :class="{'nonprint': !isPrintProccess}" name="2" v-if="approvalInfo.processList && approvalInfo.processList.length">
                <template slot="title">
                  <span class="tit">审批记录</span>
                  <el-button @click.stop="openProccessImg" type="text" class="nonprint">查看流程图</el-button>
                </template>
                <div>
                  <ProcessItem @updateInfo="changeApprovalItem" v-for="(item, index) in approvalInfo.processList" :key="index" :info="item" :approvalId="approvalInfo.approvalId" />
                </div>
              </el-collapse-item>
            </el-collapse>
          </div>
        </template>
      </div>
    </div>
    <el-button v-if="isPrint" ref="print" v-print="'#approvalPrint'" class="noneprint print-btn">打印</el-button>
  </LayoutAuto>
</template>

<script>
import {mapMutations, mapState, mapActions} from 'vuex'
import ProcessItem from '@/components/ProcessItem'
import Sponsor from '@/components/Sponsor'
import {processColor, approvalColor} from '@/utils/commonConfig';
import Print from '@/utils/print'



// https://workflow.stage.yunshanmeicai.com/#/share/:approvalId/:read -> 1
// https://workflow.stage.yunshanmeicai.com/#/approval/wait/overdue

export default {
  data() {
    return {
      activeNames: ['1', '2'],
      approvalInfo: {},
      approvalInfoLoad: false,
      approvalInfoErr: false,

      approvalId: this.$route.params.approvalId,
      tabType: '',
      type: this.$route.query?.type, 
      isPrintProccess: true,
      options: {
        height: 45,
        width: 1.3
      }
    }
  },
  computed: {
    isPrint() {
      return this.type === 'print'
    },
    statusColor(){
      return approvalColor[this.approvalInfo.statusCode]
    },
    statusNameMap() {
      if (this.approvalInfo?.statusName?.length === 2) {
        return this.approvalInfo.statusName[0] + ' ' +  this.approvalInfo.statusName[1]
      }
      return this.approvalInfo.statusName
    }
  },
  created() {
  },
  mounted() {
    this.setIsFullScreen(true)

    this.changeApprovalItem()
  },
  methods: {
    ...mapMutations('base', {
      setIsFullScreen: 'setIsFullScreen'
    }),
    changeApprovalItem(){
      
      this.approvalInfoLoad = true
      this.approvalInfoErr = false

      this.approvalInfo = {}
      _api.approval.getInfo({
        tabType: this.tabType,
        approvalId: this.approvalId
      }).then(data => {
        this.approvalInfoLoad = false
        this.approvalInfo = data
        this.activeNames = ['1', '2']
        this.$nextTick(() => {
          setTimeout(() => {
            this.handlePrint();
          }, 400)
        })

      }).catch(data => {
        if(data.message != 'cancelToken: 列表重复请求主动取消'){
          this.approvalInfoLoad = false
          this.approvalInfoErr = true
        }
      })
      
    },
    
    openProccessImg() {
      const routeData = this.$router.resolve({
        path: `/approval/proccessImg/${this.approvalInfo.approvalId}/`,
        query: { _raw: 1 }
      })
      window.open(routeData.href, '_blank');
    },

    handlePrint() {
      if (this.isPrint) { 
        this.$confirm('是否打印审批记录?', '提示', {
          confirmButtonText: '是',
          cancelButtonText: '否',
          type: 'info'
        }).then(() => {
          this.isPrintProccess = true;
        }).catch(() => {
          this.isPrintProccess = false         
        }).finally(() => {
          setTimeout(() => {
            this.$refs.print?.$el?.click()
          }, 450) 
        })        
      }
    }
  },
  components: {
    ProcessItem,
    Sponsor
  }
}
</script>

<style scoped lang="scss">
.full{
  height: auto;
}
.main-wrap{
  display: flex;
  height: calc(100% - 50px);
  background: #fff;
  margin-top: 20px;
  // border:1px solid #E4E7ED;
  // border-radius: 3px;
  width: 29.7cm; // A4
  margin: 0 auto;
  border: none;
}
.right-wrap{
  flex: 1;
  min-width: 0;
  display: flex;
  flex-shrink: 0;
  flex-direction: column;
  overflow: hidden;
  img{
    width: 129px;
    height: 115px;
    margin: auto;
  }
  .el-icon-loading{
    width: 100px;
    height: 100px;
    line-height: 100px;
    text-align: center;
    font-size: 30px;
    margin: auto;
    color: #c1c0c0;
  }
  .info-tip{
    z-index: 1;
    padding: 8px 20px;
    border-bottom: 1px solid rgba(250,236,216,1);
    background:rgba(253,246,236,1);
    color: #E6A23C;
    line-height: 20px;
    &:before{
      font-size: 16px;
      padding-right: 6px;
    }
  }
  .title{
    border-bottom: #EBEEF5 1px solid;
    margin: 20px 20px 0 20px;
    height: 38px;
    line-height: 20px;
    display: flex;
    .bar-code{
      padding-left: 20px;
      margin-top: -3px;
      .barcode {
        position: relative;
        bottom: 17px;
        left: 0;
      }
      .approval-id {
        color: #303133;
        margin-top: 3px;
      }
    }
    .name{
      flex: 1;
      font-size: 18px;
      color: #303133;
      font-weight: 500;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
      .iconquestion-circle{
        font-size: 16px;
        color: #cd2e23;
        cursor: pointer;
        &:hover{
          color: #409EFF;
        }
      }
    }
    .approval-status {
      position: relative;
      right: -40px;
      top: -10px;
      width: 83px;
      height: 24px;
      color: #FFFFFF;
      font-size: 12px;
      line-height: 24px;
      text-align: center;
      transform: rotate(45deg);
      z-index: 0;
    }

   .approval-status-print {
     font-size: 14px;
     margin-left: 20px;
   }
  }
  .form-list{
    overflow-y: scroll;
    flex: 1;
    margin: 0 20px 0 20px;
    &::-webkit-scrollbar-thumb{
      display: none;
    }
    &:hover{
      &::-webkit-scrollbar-thumb{
        display: block;
      }
    }
    /deep/ .el-collapse{
      border: 0;
      .el-collapse-item__header{
        font-size: 16px;
        color: #303133;
      }
      .el-collapse-item__wrap{
        border-bottom: 0;
      }
      .el-collapse-item__arrow{
        margin-right: 0;
      }
      .el-collapse-item__content{
        padding: 20px 0 20px 0;
      }
      .process-title .el-collapse-item__header{
        .tit{
          font-size: 16px;
          color: #303133;
        }
        .el-button{
          padding-left: 20px; 
          /deep/ span{
            /* font-size: 16px; */
          }
        }
      }
    }
    .process-item:first-of-type{
      /deep/ .top{
        display: none;
      }
    }
    .process-item:last-of-type{
      /deep/ .bot{
        display: none;
      }
    }
  }
}
/deep/ .child-form-table {
  border-left: 1px solid #E4E7ED !important;
}

.print-btn {
  opacity: 0;
  margin-top: 50px;
}
@page {
  size: A4 portrait;
  margin: 1cm 0cm 1cm 0cm;
}
</style>